import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { GoonAPIClient } from '../client/ApiClient';
import { API_ENDPOINT } from '../constants';

function convertOEmbedHtmlToIframe(oembedHtml) {
  const div = document.createElement('div');
  div.innerHTML = oembedHtml;

  const iframe = div.querySelector('iframe');
  if (!iframe) {
    console.warn('No iframe found in oEmbed HTML.');
    return null;
  }

  const src = iframe.getAttribute('src');
  //const width = iframe.getAttribute('width') || '100%';
  //const height = iframe.getAttribute('height') || '300';

  if (!src) {
    console.warn('Invalid oEmbed: Missing src.');
    return null;
  }

  // Return a lit html TemplateResult
  return html`
    <iframe
      class="h-full w-full max-h-[50dvh]"
      src=${src}
      frameborder="0"
      allowfullscreen
      loading="lazy"
      style="border: none;"
    ></iframe>
  `;
}

@customElement('link-preview')
export class LinkPreview extends LitElement {
  createRenderRoot() { return this }

  @property({ type: String }) url: string = '';
  @state() previewData: null | Record<string, unknown> = null;
  @state() previewType = '';

  async firstUpdated() {
    if (!this.url) return;
    try {
      const api = new GoonAPIClient(API_ENDPOINT);
      const res = await api.fetchLinkPreview(this.url);
      this.previewType = res.type;
      this.previewData = res.data;
    } catch (err) {
      console.error('Failed to load link preview:', err);
    }
  }

  render() {
    if (!this.previewData) return null;

    if (this.previewType === 'oembed') {
      const iframeEl = convertOEmbedHtmlToIframe(this.previewData.html);

      return html`
        <div class="mt-4 flex justify-center w-full h-[70dvh]">
          ${iframeEl}
        </div>
      `;
    }

    if (this.previewType === 'opengraph') {
      const og = this.previewData;
      const title = (og['og:title'] || ''); // truncate title to 80 chars
      const description = (og['og:description'] || ''); // truncate desc to 140 chars
      const imageUrl = og['og:image'];

      return html`
        <div class="mt-4 card bg-base-300 shadow p-4 flex gap-4">
          ${og['og:image'] ? html`
            <img src="${imageUrl}" class="h-72 object-contain object-left rounded" alt="Preview image" />
          ` : null}
          <div class="flex flex-col justify-between">
            <div class="font-bold text-base line-clamp-2">${title}</div>
            <div class="text-sm text-base-content/70 line-clamp-3">${description}</div>
            ${og['og:url'] ? html`<a href="${og['og:url']}" target="_blank" class="link link-hover text-primary-content mt-2 text-sm">${og['og:url']}</a>` : null}
          </div>
        </div>
      `;
    }

    return null;
  }
}

